import React from "react"
import "./index.css"
import App from "./App";
import { MoralisProvider } from "react-moralis";
import { createRoot } from "react-dom/client";
import { createClient, configureChains, defaultChains, WagmiConfig} from 'wagmi';
import { publicProvider } from 'wagmi/providers/public';


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
const { provider, webSocketProvider } = configureChains(defaultChains, [publicProvider()]);
const client = createClient({
    provider,
    webSocketProvider,
    autoConnect: true,
  });

root.render(
    <>
        {/* <MoralisProvider appId={"NAp8SHg5CCjvNeJIQiJ5MDtNCIxfo0YI6twV75E2"} serverUrl={"https://xesdn9euoung.usemoralis.com:2053/server"} > */}
        <WagmiConfig client={client}>
                <App />
         </WagmiConfig>
        {/* </MoralisProvider> */}
    </>
 
  );
